//规范管理
export default [
	{
		path: '/administration',
		name: 'administration',
		component: () => import('@/views/administration')
	},
	{
		path: '/Environmental',
		name: 'Environmental',
		component: () => import('@/views/administration/administra/Environmental ')
	},
	{
		path:'/system',
		name:'system',
		component:()=> import ('@/views/administration/administra/system')
	},
	{
		path:'/standard',
		name:'standard',
		component:()=> import ('@/views/administration/administra/standard')
	},
	{
		path:'/standard-Environmental',
		name:'standard-Environmental',
		component:()=> import ('@/views/administration/administra/standard-Environmental')
	}
]


// WEBPACK FOOTER //
// ./src/router/modules/administration.js